import Api from './Api';

const all = (payload) => {
    const path = '/methods';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const getAll = (payload) => {
    const path = '/get-all';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const getAllByType = (payload) => {
    const path = '/method/get-all-by-type';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const store = (payload) => {
    return Api.postRequest({
        endpoint: '/method/store',
        data: payload
    });
};

const update = (payload) => {
    return Api.postRequest({
        endpoint: '/method/update',
        method: 'PUT',
        data: payload
    });
};
const destroy = (payload) => {
    return Api.deleteRequest({
        endpoint: `/method/destroy/${payload.id}`,
    });
};

const softDelete = (payload) => {
    return Api.deleteRequest({
        endpoint: `/method/soft-delete/${payload.id}`,
    });
};

export default {
    all,
    getAll,
    store,
    update,
    destroy,
    softDelete,
    getAllByType
};
